import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';
import { withDefaultSort } from '../../utils/utility';

export const ACTION = {
  LIST: 'LIST_ENVELOP',
  GET: 'GET_ENVELOP',
  CREATE: 'CREATE_ENVELOP',
  EDIT: 'EDIT_ENVELOP',
  DELETE: 'DELETE_ENVELOP',
  DUPLICATE: 'DUPLICATE_ENVELOP',
  ADD_ZONE_ENVELOP: 'ADD_ZONE_ENVELOP',
  REMOVE_ZONE_ENVELOP: 'REMOVE_ZONE_ENVELOP',
  CLEAR_ERROR: 'CLEAR_ERROR_ENVELOP',
};

const getBaseUrl = type => {
  if (!type) {
    return Constants.API_ENVELOP;
  }

  switch (type.toLowerCase()) {
    case 'wall':
      return Constants.API_ENVELOP_WALL;
    case 'roof':
      return Constants.API_ENVELOP_ROOF;
    default:
      return Constants.API_ENVELOP;
  }
};

export const searchEnvelopByText = (text, buildingId, page = 0, zoneId = undefined) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  const sorted = withDefaultSort([]);
  const filtered = text;
  const isPublic = null;
  return searchEnvelop(pageSize, page, sorted, filtered, isPublic, buildingId, zoneId);
};

const searchEnvelop = (pageSize, page, sorted, filtered, isPublic, buildingId, zoneId = undefined) => {
  let zoneParams = { building_id: buildingId };
  if (zoneId !== undefined) {
    zoneParams = {
      ...zoneParams,
      ...(zoneId === null ? { zone_id__isnull: true } : { zone_id: zoneId }),
    };
  }

  return RestClient.request({
    method: 'get',
    url: Constants.API_ENVELOP,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
        : null,
      is_public: isPublic,
      ...zoneParams,
    },
  });
};

export const listEnvelop = (pageSize, page, sorted, filtered, isPublic, buildingId, zoneId) => {
  return {
    type: ACTION.LIST,
    payload: searchEnvelop(pageSize, page, sorted, filtered, isPublic, buildingId, zoneId)
      .catch(err => Promise.reject(err.response.data.detail)),
  };
};

export const getEnvelop = (id, type) => {
  const baseURL = getBaseUrl(type);

  return {
    type: ACTION.GET,
    payload: RestClient.request({
      method: 'get',
      url: `${baseURL}${id}/`,
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const createEnvelop = (name, zoneId, azimuthAngle, inclination, description, type, buildingId) => {
  const formData = new FormData();
  formData.set('name', name);
  formData.set('zone_id', zoneId || '');
  formData.set('azimuth_angle', azimuthAngle);
  formData.set('inclination', inclination);
  if (typeof description === 'string') formData.set('description', description);
  formData.set('building_id', buildingId);

  const baseURL = getBaseUrl(type);
  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: baseURL,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editEnvelop = (id, name, zoneId, azimuthAngle, inclination, description, type) => {
  const formData = new FormData();
  if (name) formData.set('name', name);
  formData.set('zone_id', zoneId || '');
  if (azimuthAngle) formData.set('azimuth_angle', azimuthAngle);
  if (inclination) formData.set('inclination', inclination);
  if (typeof description === 'string') formData.set('description', description);

  const baseURL = getBaseUrl(type);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${baseURL}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteEnvelop = envelopeId => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_ENVELOP}${envelopeId}/`,
    })
      .then(() => ({ id: envelopeId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const duplicateEnvelop = (envelopeId, name, type) => {
  const data = { new_name: name };
  const baseURL = getBaseUrl(type);

  return {
    type: ACTION.DUPLICATE,
    payload: RestClient.request({
      method: 'post',
      url: `${baseURL}${envelopeId}/copy/`,
      data,
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const addEnvelopToZone = (id, zoneId) => {
  const formData = new FormData();
  formData.set('zone_id', zoneId);

  return {
    type: ACTION.ADD_ZONE_ENVELOP,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_ENVELOP}${id}/`,
      data: formData,
    })
      .then(response => response.data)
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const removeEnvelopFromZone = id => {
  const formData = new FormData();
  formData.set('zone_id', '');

  return {
    type: ACTION.REMOVE_ZONE_ENVELOP,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_ENVELOP}${id}/`,
      data: formData,
    })
      .then(() => ({ id }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const clearErrorEnvelop = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};



// WEBPACK FOOTER //
// ./src/redux/envelop/envelop_actions.js